"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingQueries = exports.trackingQueryKeys = void 0;
const tracking_api_1 = require("./tracking.api");
exports.trackingQueryKeys = {
    all: () => ['tracking'],
    details: ({ hash }) => [...exports.trackingQueryKeys.all(), 'details', hash],
    timeline: (hash) => [...exports.trackingQueryKeys.all(), 'timeline', hash],
};
const trackingQueries = (apiOptions) => ({
    getDetails: (hash) => ({
        queryKey: exports.trackingQueryKeys.details(hash),
        queryFn: () => (0, tracking_api_1.getDetails)(apiOptions, hash),
    }),
    getTimeline: (hash) => ({
        queryKey: exports.trackingQueryKeys.timeline(hash),
        queryFn: () => (0, tracking_api_1.getTimeline)(apiOptions, hash),
    }),
});
exports.trackingQueries = trackingQueries;
//# sourceMappingURL=tracking.queries.js.map